import { useState, useRef, useLayoutEffect, useEffect } from 'react';
import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';
import { Paginator, Avatar, Colors, ScrollSnap, Typography, } from '../../../index';
import { remapDeprecatedColors, breakpoints, } from '../TestimonialSolo/TestimonialMapping';
import { css } from '@emotion/react';
import { debounce } from '../../../utils/debounce';
const Styles = labelStyles('testimonialCarousel', {
    testimonialCarouselContainer: (backgroundColor = 'neutral100') => css `
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: ${Colors[remapDeprecatedColors(backgroundColor)]};
    padding: 20px;
    @media screen and (min-width: ${breakpoints.tablet}px) {
      padding: 40px 30px;
    }
  `,
    testimonialContainerWrapper: css `
    width: 100%;
    display: flex;
    overflow-x: auto;
    gap: 40px;
    // Fits inside our 1230px max grid, plus about 100px of padding on each side of the carousel
    // so that it is centered and not quite as wide as a Hero, for example
    max-width: 1030px;
    &::-webkit-scrollbar {
      /* Hide scrollbar for Chrome, Safari and Opera */
      display: none;
    }
    -ms-overflow-style: none; /* Hide scrollbar for IE and Edge */
    scrollbar-width: none; /* Hide scrollbar for Firefox */
    @media screen and (min-width: ${breakpoints.tablet}px) {
      gap: 60px;
    }
  `,
    testimonialContainer: css `
    min-width: 100%;
    display: grid;
    align-items: flex-start;
    grid-template-columns: repeat(1,1fr);
    gap: 30px 0;
    margin-bottom: 30px;
    @media screen and (min-width: ${breakpoints.tablet}px) {
      grid-template-columns: repeat(2,1fr);
      gap: 0 30px;
    }
    @media screen and (min-width: ${breakpoints.desktop}px) {
      margin-bottom: 40px;
      gap: 0 100px;
    }
  }
  `,
    testimonial: css `
    text-align: left;
    @media screen and (min-width: ${breakpoints.tablet}px) {
      max-width: 339px;
    }
    @media screen and (min-width: ${breakpoints.desktop}px) {
      max-width: 400px;
    }
  `,
    avatarContainer: css `
    margin-bottom: 20px;
  `,
    quote: css `
    ${Typography.paragraph3}
    color: ${Colors.neutral800};
    margin-bottom: 20px;

    @media screen and (min-width: ${breakpoints.tablet}px) {
      ${Typography.subHeader1}
    }
  `,
    author: css `
    ${Typography.paragraph3}
    color: ${Colors.neutral700};
  `,
});
export const TestimonialCarousel = (props) => {
    const [activeTestimonialIndex, setActiveTestimonialIndex] = useState(0);
    const testimonialContainerRef = useRef(null);
    const [testimonialContainerWidth, setTestimonialContainerWidth] = useState(0);
    useEffect(() => {
        var _a;
        setTestimonialContainerWidth(((_a = testimonialContainerRef === null || testimonialContainerRef === void 0 ? void 0 : testimonialContainerRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) || 0);
    }, []);
    useLayoutEffect(() => {
        const onResize = debounce(() => {
            var _a;
            setTestimonialContainerWidth(((_a = testimonialContainerRef === null || testimonialContainerRef === void 0 ? void 0 : testimonialContainerRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) || 0);
        }, 100);
        window.addEventListener('resize', onResize, { capture: true });
        return () => {
            window.removeEventListener('resize', onResize, { capture: true });
        };
    });
    const paginator = (isolateComponent(Paginator, { currentPageIndex: activeTestimonialIndex, onPaginate: ({ pageIndex: index }) => setActiveTestimonialIndex(index), pageUrls: Array.from({ length: props.testimonials.length }) }));
    return (isolateComponent("div", { css: Styles.testimonialCarouselContainer(props.backgroundColor) },
        isolateComponent("div", { css: Styles.testimonialContainerWrapper, ref: testimonialContainerRef }, testimonialContainerWidth && (isolateComponent(ScrollSnap, { gap: 60, itemWidth: testimonialContainerWidth, onScroll: (index) => {
                setActiveTestimonialIndex(index);
            }, pageIndex: activeTestimonialIndex, scrollSnapAlign: "center" }, props.testimonials.map((testimonial, i) => (isolateComponent("div", { key: i, css: Styles.testimonialContainer },
            isolateComponent("div", null, testimonial.mediaElement),
            isolateComponent("div", { css: Styles.testimonial },
                testimonial.hasAuthorAvatar && (isolateComponent("div", { css: Styles.avatarContainer },
                    isolateComponent(Avatar, { "data-testId": "Avatar", name: testimonial.author, url: testimonial.avatarUrl, size: 40 }))),
                isolateComponent("div", { css: Styles.quote }, testimonial.quote),
                isolateComponent("p", { css: Styles.author },
                    testimonial.author,
                    ", ",
                    testimonial.company)))))))),
        paginator));
};
//# sourceMappingURL=TestimonialCarousel.js.map
// @zapier/design-system@6.14.1 (10126c41d)
